import React, { useEffect } from "react";

import Image from "next/image";

import { Alert, Box, Button, Container, Grid, Typography } from "@mui/material";

import { FormProvider, useForm } from "react-hook-form";

import DecorImage from "../../../public/static/contact/props.png";
import {
  StandardRadioGroup,
  StandardTextField,
} from "../../components/standard-form-fields";
import useFormPersist from "../../hooks/useFormPersist";

const FORM_INITIAL_DEFAULT_VALUES = {};

const ContactView = ({
  formDefaultValues = FORM_INITIAL_DEFAULT_VALUES,
  loading,
  onFormDirtyChanged,
  onSubmit,
  submitted,
  ...props
}) => {
  const formMethods = useForm({ defaultValues: formDefaultValues });
  const {
    getValues,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { isDirty },
  } = formMethods;
  useFormPersist("form-contact", { watch, reset, setValue });

  useEffect(() => {
    if (submitted) {
      const submittedState = getValues();
      reset({ ...submittedState, enquiry: "", detail: "" });
    }
  }, [submitted, getValues, reset]);

  useEffect(() => {
    if (onFormDirtyChanged) onFormDirtyChanged(isDirty);
  }, [isDirty, onFormDirtyChanged]);

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        pt: 2,
        pb: 16,
      }}
      {...props}
    >
      <Container maxWidth="lg">
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Box sx={{ mx: "auto", my: 2, width: "80%" }}>
              <Image src={DecorImage} layout="responsive" placeholder="empty" />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box mb={4}>
              <Typography variant="h5">聯絡我們</Typography>
            </Box>
            {submitted && (
              <Alert severity="success">
                感謝您，我們已經收到您的資料，將儘快處理!
              </Alert>
            )}
            <FormProvider {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>
                  <StandardTextField
                    name="name"
                    required
                    label="姓名"
                    placeholder="您的姓名"
                    registerProps={{
                      required: "請提供姓名以便聯絡",
                    }}
                  />
                  <StandardRadioGroup
                    name="title"
                    choices={[
                      { value: "mr", label: "先生" },
                      { value: "miss", label: "小姐" },
                      { value: "mrs", label: "女士" },
                      { value: "dr", label: "博士" },
                    ]}
                    required
                    label="稱謂"
                    registerProps={{ required: "請選擇稱謂以便聯絡" }}
                  />
                  <StandardTextField
                    name="company"
                    label="公司"
                    placeholder="您的公司名稱"
                  />
                  <StandardTextField
                    name="email"
                    required
                    label="電郵地址"
                    placeholder="我們回覆您的電郵地址"
                    registerProps={{
                      required: "請提供電郵地址以便聯絡",
                      pattern: {
                        value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/,
                        message: "您的電郵地址可能有誤，請檢查後再試一次",
                      },
                    }}
                  />
                  <StandardTextField
                    name="phone"
                    label="聯絡電話號碼"
                    placeholder="請留下聯絡電話號碼及時段，我們以電話回覆"
                  />
                  <StandardRadioGroup
                    name="enquiry"
                    choices={[
                      { value: "outsource", label: "委託作畫" },
                      { value: "marketing", label: "市場推廣" },
                      { value: "creator", label: "成為創作者" },
                      { value: "collab", label: "合作提案" },
                      { value: "others", label: "其他" },
                    ]}
                    required
                    label="查詢類型"
                    registerProps={{
                      required: "請告訴我們您感興趣的項目類型",
                    }}
                  />
                  <StandardTextField
                    name="detail"
                    label="查詢內容詳情"
                    placeholder="請寫下您想查詢的事項，我們會於2工作天內儘快回覆"
                    textFieldProps={{
                      multiline: true,
                      minRows: 5,
                    }}
                  />
                  <Grid item xs={12}>
                    {submitted && (
                      <Alert severity="success">
                        感謝您，我們已經收到您的資料，將儘快處理!
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button
                      type="submit"
                      color="primary"
                      disabled={loading}
                      fullWidth
                      sx={{ minWidth: "100px" }}
                      variant="contained"
                    >
                      {loading ? "正在提交..." : "提交"}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button
                      onClick={() => reset()}
                      disabled={loading}
                      fullWidth
                      sx={{ minWidth: "100px" }}
                      variant="outlined"
                    >
                      清除
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </FormProvider>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactView;
